module.exports = __webpack_public_path__ + "media/images/navbar-logo-93a3f2d69cc78c241b491018b420839c.png";